// extracted by mini-css-extract-plugin
module.exports = {"container":"g0","containerExpand":"g1","headerRow":"g2","headerCol":"g3","image":"g4","title":"g5","date":"g6","dateExpand":"g7"};